import { ComponentsProps } from '@mui/material';

import CheckMarkFillIcon from '@o2/icons/CheckMarkFill';
import ExclamationMarkFillIcon from '@o2/icons/ExclamationMarkFill';
import CrossFillIcon from '@o2/icons/CrossFill';
import InfoFillIcon from '@o2/icons/InfoFill';

type AlertDefaultProps = NonNullable<ComponentsProps['MuiAlert']>;

const defaultProps: AlertDefaultProps = {
  variant: 'filled',
  elevation: 6,
  iconMapping: {
    success: <CheckMarkFillIcon fontSize="inherit" />,
    warning: <ExclamationMarkFillIcon fontSize="inherit" />,
    error: <CrossFillIcon fontSize="inherit" />,
    info: <InfoFillIcon fontSize="inherit" />,
    internal: <InfoFillIcon fontSize="inherit" />,
    // cast necessary due to added 'internal'
  } as AlertDefaultProps['iconMapping'],
};

export default defaultProps;
